import React, { useEffect, useImperativeHandle, useState } from "react";
import styled from "styled-components";
import FloatLayout from "@/components/float-layout";
import bridge from '@/config/JSbridge';
import ShareWeixin from '../imgs/share/share_icon_weixin@2x.png';
import ShareWeixinFriend from '../imgs/share/share_icon_friends@2x.png';
import ShareWeibo from '../imgs/share/share_icon_weibo@2x.png';
import ShareQQ from '../imgs/share/share_icon_qq@2x.png';
import { bg_color1, color2, color1, border_color } from '@/styles/theme';
import { isStorm, handleUploadTrace } from "../stock";

const socialList = {
  qq: ShareQQ,
  wechat_friend: ShareWeixinFriend,
  wechat: ShareWeixin,
  // wechat_collect: 0,
  weibo: ShareWeibo,
  // sns: 0,
  // qzone: 0,
  // snapshot: 0
};

const socialItemName = {
  qq: 'QQ',
  wechat_friend: '朋友圈',
  wechat: '微信',
  weibo: '微博',
}

const ShareModal = React.forwardRef(({onShareClick, income, shareText = ''}, ref) => {
  const [visible, setVisible] = useState(false);
  const [social, setSocial] = useState([]);

  useImperativeHandle(ref, () => {
    return {
      show: () => setVisible(true)
    }
  })

  const showCanShare = (data) => {
    if (data.length > 0) {
      const nextSocialList = [];
 
      if (data.indexOf("wechat") !== -1) {
        nextSocialList.push('wechat')
      }
      if (data.indexOf("wechat_friend") !== -1) {
        nextSocialList.push('wechat_friend')
      }
      if (data.indexOf("weibo") !== -1) {
        // socialList.weibo = 1
        nextSocialList.push('weibo')
      }
      if (data.indexOf("qq") !== -1) {
        nextSocialList.push('qq')
      }
      
      // if (data.indexOf("wechat_collect") !== -1) {
      //   socialList.wechat_collect = 1
      // }
      
      // if (data.indexOf("sns") !== -1) {
      //   socialList.sns = 1
      // }
      // if (data.indexOf("qzone") !== -1) {
      //   socialList.qzone = 1
      // }
      // if (data.indexOf("snapshot") !== -1) {
      //   socialList.snapshot = 1
      // }
      setSocial(nextSocialList);
      /** */
      handleUploadTrace('share_window-success');
      /** */
    }
  };

  const canShare = () => {
    let send = {
      event: "validSocial",
      params: {
        social: [
          "qq",
          "wechat_friend",
          "wechat",
          "wechat_collect",
          "weibo",
          "sns",
          "qzone",
          "snapshot"
        ]
      }
    };
    bridge.callHandler('nativeEvent', send, res => {
      const result = JSON.parse(res);
      // console.log(result, 'result')
      if (result.code === 0) {
        const social = result.params.social;
        showCanShare(social);
      }
    })
  };

  useEffect(() => {
    
    canShare();
  }, []);

  const handleShare = (item) => {
    let sendData = {
      event: 'webData',
      params: {
        action: 'essayData',
        data: {
          C_TITLE: income ? `我全年收益${income}，你呢？` : '牛回！速来股神模拟器！',
          C_TITLE_IMG: 'https://file.wogoo.com/app/logo/logo7.png',
          C_INTRODUCE: "假如2023重来，试试你炒股能赚多少钱",
          C_IMG: "",
          ARTICLE_ID: 'a76767d26311439786c35ea8dc11a253',
          C_CONTENT: '123',
          shareImg: 'https://file.wogoo.com/app/logo/logo7.png',
          share_url: process.env.REACT_APP_DEMAND_URL + 'active_31',
        }
      }
    }
    bridge.callHandler('nativeEvent', sendData, res => {})
    const event = {
      event: 'shareToSocial',
      params: {
        title: income ? `我全年收益${income}，你呢？` : '牛回！速来股神模拟器！',
        subtitle: '假如2023重来，试试你炒股能赚多少钱',
        image: 'https://file.wogoo.com/app/logo/logo7.png',
        url: process.env.REACT_APP_DEMAND_URL + 'active_31',
        articleID: '',
        social: item
      }
    }
    bridge.callHandler('nativeEvent', event, res => {
      const result = JSON.parse(res);
      if (result.code === 0) {}
    });
    onShareClick(item);

    bridge.callHandler(
      'nativeEvent',
      {
        event: 'nativeControl',
        params: {
          navigation: {
            visibility: false
          },
          container: {},
          bottomToolbar: {
            visibility: false
          }
        }
      },
      () => {}
    );
  }

  if (!isStorm) {
    return;
  }

  return (
    <FloatLayout
      content={
        <Container className="float-table-wrap">
          {social.length > 0 && <div className="share-text">{shareText || '分享后获取重玩机会'}</div>}
          {social.length === 0 && <div className="share-text">暂无分享渠道</div>}
          <div className="social-wrap">
            {social.map(item => {
              return <div onClick={() => handleShare(item)} className="social-item">
                <img src={socialList[item]} alt='' className="social-img"/>
                <div className="social-item-text">{socialItemName[item]}</div>
              </div>
            })}
          </div>
          <div onClick={() => setVisible(false)} className="cancel-share">取消</div>
        </Container>
      }
      visible={visible}
      onOverlayClick={() => setVisible(false)}
    />
  )
})

export default React.memo(ShareModal);

export const Container = styled.div`
  background-color: ${bg_color1};
  width: 100%;
  border-radius: 14px 14px 0px 0px;
  .share-text {
    font-size: 14px;
    font-weight: 400;
    color: ${color1};
    line-height: 19px;
    padding: 18px 0 0 20px;
  }
  .social-wrap {
    height: 100%;
    display: flex;
    align-items: center;
    overflow-x: scroll;
    overflow-y: hidden;
    padding: 18px 20px 14px;
    .social-item {
      margin-right: 22px;
      display: flex;
      flex-direction: column;
      align-items: center;
      &:last-child {
        margin-right: 0px;
      }
      .social-img {
        width: 48px;
        height: 48px;
      }
      .social-item-text {
        font-size: 12px;
        font-weight: 400;
        color: ${color2};
        line-height: 17px;
        margin-top: 6px;
      }
    }
  }
  .cancel-share {
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    color: ${color1};
    line-height: 25px;
    margin: 0 20px;
    padding-top: 14px;
    padding-bottom: 14px;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid ${border_color};
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/components/share.js